const div = document.createElement('div');

/**
 * Given an HTML string, strip out any HTML tags
 * @param {String} html  The HTML string
 * @returns {String}
 */
export default function stripTags(html) {
	div.innerHTML = html;
	return div.textContent || div.innerText || '';
}
